// Текст, набраний в адмінці, — рядок у рядок.
//
// ⚠️ До 2026-09-09 пункти розділялися крапкою з комою, і сайт різав текст по
// `;`. Це означало, що набране в адмінці й показане на сайті — різні речі:
// власник бачив суцільний абзац, а сайт малював список. Тепер розділювач —
// звичайний перенос рядка, той самий, який видно в полі.
//
// ⚠️ Кінцева `;` зрізається навмисно. У базі лежать сотні записів у старому
// форматі («Ємність: 4000 mAh;»), і без цього вона світилася б у кінці кожного
// пункту. Перевірено на живих даних: жоден запис не тримає кілька пунктів в
// ОДНОМУ рядку через `;`, тож поділ по рядках нічого не склеює.
//
// Крапка з комою всередині рядка лишається як є — вона там частина тексту.
export const splitTextLines = (text?: string): string[] =>
  (text ?? '')
    .split(/\r?\n/)
    .map(line => line.trim().replace(/;+$/, '').trim())
    .filter(Boolean);

// Той самий текст, але одним блоком — зі збереженою розкладкою.
//
// ⚠️ Різниця зі splitTextLines принципова. Список пунктів («Технічні
// особливості») потрібно розбити на елементи. А «Опис» — це суцільний текст, у
// якому власник САМ вирішує, де щільний рядок, а де порожній рядок між
// блоками. Розбивати його на абзаци з однаковим відступом означало б
// перемалювати чужу верстку: підзаголовок «Особливості підключення:»
// відривався від своїх пунктів 1 і 2, бо між ними з'являвся такий самий
// проміжок, як між розділами.
//
// Тому тут рядки НЕ фільтруються й НЕ склеюються: порожній рядок лишається
// порожнім рядком, а показує його CSS через `white-space: pre-wrap`.
// Зрізається лише стара `;` у кінці рядка — з тієї ж причини, що й вище.
export const toTextBlock = (text?: string): string =>
  (text ?? '')
    .split(/\r?\n/)
    .map(line => line.replace(/;+\s*$/, '').trimEnd())
    .join('\n')
    .trim();
